<template>
    <v-snackbar
        ref="snack-bar"
        v-model="isShow"
        :class="$options.name"
        :top="true"
        :right="true"
        :timeout="5000"
        :color="backgroundColor"
    >
        <span class="message" v-text="toastMessage" />
        <template v-slot:action="{ attrs }">
            <v-btn icon dark v-bind="attrs" @click="isShow = false">
                <v-icon>check</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'ToastBox',
})
export default class ToastBox extends Vue {
    @Prop({ default: '' }) message: string;
    @Prop({ default: '' }) color: string;
    @Watch('toastMessage')
    onToastMessageChanged(val: string): void {
        if (val !== '') this.isShow = true;
    }
    @Watch('isShow')
    onIsShowChanged(val: boolean): void {
        if (!val) this.$emit('close');
    }

    isShow = false;

    get toastMessage(): string {
        return this.message;
    }
    set toastMessage(val) {
        this.message = val;
    }
    get backgroundColor(): string {
        return this.color;
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
.ToastBox {
    &.v-snack--absolute {
        z-index: 1000;
    }
}
</style>
